<video autoplay #localVideoElement
       id="localVideoElement"
       class="videoElementCSS" width="640"
       height="480"></video>
<canvas id="canvasLocalOutput" [style.display]="((faceRecognitionService.started)? 'block': 'none')" width="640"
        height="480"
        #canvasLocalOutput class="canvasElementCSS">
</canvas>

<h1 *ngIf="cameraService.errMsg" style="color: red" class="text-center">
  {{cameraService.errMsg}}
</h1>
<div *ngIf="faceRecognitionService.foundFace && emotionService.emotionMaxIcon" id="emotionIcon">
  <span style="font-size: 6vw">
    {{emotionService.emotionMaxIcon}}
  </span>
</div>
<div id="emotionText" class="text-center" *ngIf="faceRecognitionService.started">
  <span class="blink_me" style="font-size: larger; color:red" *ngIf="!faceRecognitionService.foundFace">
     No Face
  </span>
  <span style="font-size: larger" *ngIf="faceRecognitionService.foundFace && emotionService.emotionMaxText">
    {{emotionService.emotionMaxText}}
  </span>
</div>

<div id="foundFace" *ngIf="faceRecognitionService.started">
  <img *ngIf="faceRecognitionService.foundFace" src="assets/images/face-detection_yes.svg" height="48" width="48">
  <img *ngIf="!faceRecognitionService.foundFace" src="assets/images/face-detection_no.svg" height="48" width="48">
</div>


